import { LetterheadBackgroundColor } from 'types/graphql'

import { TailwindColor } from 'src/constants/theme/tailwind'

/**
 * Default logo size in pixels for letterhead center files.
 */
export const DEFAULT_LETTERHEAD_LOGO_SIZE_PX = 80

const LIGHT_BACKGROUNDS: LetterheadBackgroundColor[] = ['White']

const BACKGROUND_COLOR_HEX_MAP: Record<LetterheadBackgroundColor, string> = {
  Black: TailwindColor.Black,
  DarkBlue: TailwindColor.GovWellBlue,
  DarkGray: TailwindColor.Gray700,
  DarkGreen: TailwindColor.Green900,
  Maroon: TailwindColor.Red900,
  Navy: TailwindColor.Blue950,
  White: TailwindColor.White,
}

/**
 * Human-readable display labels for letterhead background colors.
 */
export const LETTERHEAD_BACKGROUND_COLOR_LABELS: Record<LetterheadBackgroundColor, string> = {
  Black: 'Black',
  DarkBlue: 'Dark Blue',
  DarkGray: 'Dark Gray',
  DarkGreen: 'Dark Green',
  Maroon: 'Maroon',
  Navy: 'Navy',
  White: 'White',
}

/**
 * Ordered list of letterhead background colors for UI display.
 */
export const LETTERHEAD_BACKGROUND_COLORS: LetterheadBackgroundColor[] = [
  'White',
  'Black',
  'DarkBlue',
  'DarkGray',
  'DarkGreen',
  'Maroon',
  'Navy',
]

/**
 * Determines the appropriate text color for a letterhead based on its background color.
 * Returns black for light backgrounds, white for dark backgrounds.
 */
export const getLetterheadTextColor = (
  backgroundColor: LetterheadBackgroundColor | null | undefined
): string => {
  if (!backgroundColor || LIGHT_BACKGROUNDS.includes(backgroundColor)) {
    return TailwindColor.Black
  }
  return TailwindColor.White
}

/**
 * Converts the enum value to a hex color for rendering.
 */
export const getLetterheadBackgroundHex = (
  backgroundColor: LetterheadBackgroundColor | null | undefined
): string => {
  return BACKGROUND_COLOR_HEX_MAP[backgroundColor ?? 'White']
}
